<template>
	<div class="sampleInforClass">
		<div class="leftClass">
			<span :class="activeIndex == index ? 'spanNameClass2' : 'spanNameClass'" v-for="(item, index) in navItems" :key="index" @click="changeItem(item, index)" :title="item.name">
				<img :src="activeIndex == index ? item.img1 : item.img2" />
				{{ item.name }}
			</span>
		</div>
		<div class="rightClass">
			<div v-html="contentObj.content"></div>
			<!-- <sampleTypeVue v-if="activeIndex == 0"></sampleTypeVue> -->
			<!-- <sampleBorrwiongVue v-if="activeIndex == 1"></sampleBorrwiongVue>
      <sampleReturnVue v-else-if="activeIndex == 2"></sampleReturnVue> -->
		</div>
	</div>
</template>

<script>
// import sampleBorrwiongVue from './sampleBorrwing.vue'
// import sampleTypeVue from './sampleType.vue'
// import sampleReturnVue from './sampleReturn.vue'
export default {
	components: {
		// sampleTypeVue,
		// sampleBorrwiongVue,
		// sampleReturnVue
	},
	data() {
		return {
			ruleFlag: true,
			activeIndex: 0,
			dataObject: [],
			contentObj: {}
		}
	},
	computed: {
		navItems() {
			return [{ img1: require('./../../../assets/moonsamples/编号1.png'), img2: require('./../../../assets/moonsamples/编号2.png'), name: this.$t('MoonSample.SampleNumberRules') }]
		}
	},
	mounted() {
		this.initDataFunc()
	},
	methods: {
		async initDataFunc() {
			let res = await this.$http.get(this.$const.moonSample.sampleAboutUS + `?pageNum=1&pageSize=10&type=2`)
			if (res && res.code == 200) {
				res.data.forEach((element) => {
					if (element.title == '样品编号规则') {
						this.contentObj = element
					}
				})
			}
		},
		changeItem(item, index) {
			this.activeIndex = index
			console.log(item)
		}
	}
}
</script>

<style lang="scss" scoped>
.sampleInforClass {
	width: 1200px;
	margin: 0 auto;
	margin-top: 20px;
	display: flex;
	justify-content: space-between;
	margin-bottom: 20px;
	.leftClass {
		width: 240px;
		border-radius: 4px;
		background-color: #fff;
		.spanNameClass,
		.spanNameClass2 {
			cursor: pointer;
			height: 40px;
			font-family: MicrosoftYaHeiUI;
			font-size: 18px;
			color: #333333;
			display: flex;
			font-style: normal;
			align-items: center;
			line-height: 40px;
			padding-top: 20px;
			padding-left: 20px;
			img {
				padding-right: 10px;
			}
		}
		.spanNameClass2 {
			color: #2a8eec;
			white-space: nowrap;
			overflow: hidden;
			height: auto;
			text-overflow: ellipsis;
		}
	}
	.rightClass {
		display: flex;
		width: 900px;
		flex-direction: column;
	}
}
</style>
<style>
.sampleInforClass .rightClass p {
	height: 80px;
	font-style: normal;
	display: block;
	line-height: 80px;
	font-family: MicrosoftYaHeiUISemibold;
	font-size: 28px;
	color: #000000;
	text-align: left;
	font-style: normal;
}
.sampleInforClass .rightClass ul {
	font-family: MicrosoftYaHeiUI;
	font-size: 18px;
	color: #333333;
	line-height: 38px;
	text-align: left;
	font-style: normal;
	text-indent: 2em;
}
</style>